export default [
  {
    path: '/kanban',
    name: 'kanban',
    component: () => import('@/views/kanban/index.vue'),
    meta: {
      public: false,
      title: "kanban.Baslik",
      yetki: { k: [1022102] },
    },
  },
  {
    path: '/kanban/item/:id',
    name: 'kanban-item-edit',
    component: () => import('@/views/kanban/KanbanItemEdit.vue'),
    meta: {
      public: false,
      title: "kanban.Gorevi Duzenle",
      yetki: { k: [1022102] },
    },
  },
]
